import React from 'react';
import {
    HeaderGridContainer,
    HeaderTextContainer,
    GridContainer,
    ItemCardTextContainer,
    DeleteBtnDiv,
    BatchNum,
    SetDesc,
    SetNum,
    AccountName,
    DesktopSetsDiv,
    BarCode,
} from './index.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import DeleteDarkIcon from 'src/assets/images/DeleteDarkIcon.svg';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import {
    bulkBarcodeDetailsData,
    deleteAllSets,
    resetBulkBarcodeDetailsData,
    // resetBulkBarcodeDetailsData,
    resetCreateReceiveSets,
    resetTerritoryReceiveSets,
    saveReceiveSetsDetails,
    saveSetsOutsideTerritoryList,
    setBarcodeDetails,
    setProductDetails,
} from 'src/pages/receiveSets/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { BoxView } from 'src/pages/reportUsage/common/Common.styled.jsx';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { useTranslation } from 'react-i18next';
  
export default function DesktopSetsList({
    setsList,
    setListArr,
    counterMessage,
    setCounterMessage,
}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const setsOutsideTerritoryList = useSelector(
        (state) => state.receiveSetsListDataReducer.setsOutsideTerritoryList
    );
    const getUniqueBarcode =  [...new Map(setsList.map(item => [item['barcode'], item])).values()];
    const handleDeleteAll = () => {
        setCounterMessage(0);
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(setProductDetails());
        dispatch(resetCreateReceiveSets([]));
        dispatch(resetTerritoryReceiveSets([]));
        dispatch(saveReceiveSetsDetails([]));
        dispatch(resetBulkBarcodeDetailsData([]));
    };
    const handleIndividualItemDelete = (index) => {
        const updatedSetsOutsideTerritoryList = setsOutsideTerritoryList.filter(
            (item) => item.barcode !== setsList[index].barcode
        );

        dispatch(saveSetsOutsideTerritoryList(updatedSetsOutsideTerritoryList));

        if (setsList[index]) {
            if (setsList[index].isFromBarcode) {
                setCounterMessage(counterMessage - 1);
            }
            setsList.splice(index, 1);
        }
        setListArr(setsList);
        dispatch(saveReceiveSetsDetails(setsList));
    };
    return (
        <DesktopSetsDiv>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={6}
                >
                    {t('receiveSets.ReceiveSetsLoc.DesktopSetsList.sets')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={6}
                >
                    {t('receiveSets.ReceiveSubmit.ReceivedSets.batch')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={6}
                >
                    {t('receiveSets.ReceiveSetsLoc.DesktopSetsList.currentLocation')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={2}
                    md={2}
                    lg={2}
                    xl={2}
                    mobile={6}
                    style={{ textAlign: 'right' }}
                >
                    <DeleteBtnDiv>
                        <div
                          id="receivesets-desktopsetslist-deleteall-text"
                            onClick={handleDeleteAll}
                            style={{
                                marginRight: '5px',
                                color: '#1010EB',
                                cursor: 'pointer',
                            }}
                        >
                            {t('receiveSets.ReceiveSetsLoc.DesktopSetsList.deleteAll')}
                        </div>
                        <div>
                            <img
                             id="receivesets-desktopsetslist-deleteall-icon"
                                src={DeleteDarkIcon}
                                style={{
                                    cursor: 'pointer',
                                    marginTop: '3px',
                                    width: '10px',
                                }}
                                onClick={handleDeleteAll}
                            />
                        </div>
                    </DeleteBtnDiv>
                </HeaderTextContainer>
            </HeaderGridContainer>
            {setsList &&
                setsList.map((item, index) => {
                    return (
                        <GridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                            key={index}
                        >
                            <ItemCardTextContainer
                                item
                                xs={6}
                                sm={4}
                                md={4}
                                lg={4}
                                xl={4}
                                mobile={6}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                    }}
                                >
                                    {!item.isBarCode && (
                                        <BoxView
                                            mr={'4px'}
                                            bgBorder={'1px solid #7ECA2A'}
                                            bgColor={'#7ECA2A80'}
                                            scrWidth={'21px'}
                                            mTop={'4px'}
                                            bRadius={'4px'}
                                        >
                                            <CustomLabel
                                                fSize={'10px!important'}
                                                letterSpacing={'0px !important'}
                                                pt={'2px!important'}
                                                fontFamily={
                                                    'AvenirNextWorld Demi'
                                                }
                                                opacity={'1'}
                                                lineHeight={'20px'}
                                                color={'#140F4B'}
                                                label={'M'}
                                            />
                                        </BoxView>
                                    )}

                                    <SetNum
                                        display={'flex'}
                                        alignItems={'baseline'}
                                    >
                                        {item.setNo}
                                        <BarCode>
                                            &nbsp;|&nbsp;{t('receiveSets.ReceiveSetsLoc.AddSetsLists.titleBarCode')} {item.barcode}
                                        </BarCode>
                                    </SetNum>
                                </div>

                                <SetDesc>
                                    {item.description ? item.description : ''}
                                </SetDesc>
                            </ItemCardTextContainer>
                            <ItemCardTextContainer
                                item
                                xs={6}
                                sm={3}
                                md={3}
                                lg={3}
                                xl={3}
                                mobile={6}
                            >
                                <BatchNum>{item.batchNo}</BatchNum>
                            </ItemCardTextContainer>
                            <ItemCardTextContainer
                                item
                                xs={6}
                                sm={3}
                                md={3}
                                lg={3}
                                xl={3}
                                mobile={6}
                            >
                                <AccountName className="receive-sets-account-dt-mask">
                                    {item?.accountName}{' '}
                                    {accountNumberZeroTrimmer(
                                        item?.accountCode
                                    )}
                                </AccountName>
                            </ItemCardTextContainer>
                            <ItemCardTextContainer
                                item
                                xs={6}
                                sm={2}
                                md={2}
                                lg={2}
                                xl={2}
                                mobile={6}
                                style={{ textAlign: 'right' }}
                            >
                                <img
                                id="receivesets-desktopsetslist-individual-delete-icon"
                                    src={DeleteLight}
                                    alt={'delete'}
                                    style={{
                                        cursor: 'pointer',
                                        border: '1px solid #f5f5f5',
                                        borderRadius: '6px',
                                        width: '25px',
                                        background:
                                            '0% 0% no-repeat padding-box padding-box rgb(255, 255, 255)',
                                        boxShadow:
                                            'rgb(0 0 0 / 16%) 0px 0px 2px',
                                    }}
                                    onClick={() =>
                                        handleIndividualItemDelete(index)
                                    }
                                />
                            </ItemCardTextContainer>
                        </GridContainer>
                    );
                })}
        </DesktopSetsDiv>
    );
}
